/* FuelHer story (TG-24): UI for sections/fhs-pdp-story.liquid.
   Tabs, pillars, FAQ, supply picker + add to cart, stir video, and the
   lazy-loaded 3D hero (assets/fhs-hero.js on three.js r149). */
(function () {
  'use strict';

  var HERO = {
    desktop: { width: 1440, height: 860, bagCenterY: 505, bagHeight: 3.0, aspect: 0.79, depth: 0.34, fontPx: 118,
      numbers: [{ x: 290, y: 540, w: 160 }, { x: 1150, y: 540, w: 325 }] },
    mobile: { width: 390, height: 780, bagCenterY: 380, bagHeight: 2.0, aspect: 0.79, depth: 0.23, particles: 20000, fontPx: 60,
      numbers: [{ x: 82, y: 612, w: 80 }, { x: 252, y: 612, w: 190 }] }
  };
  var MOBILE_MAX = 749, MOBILE_SCALE_CAP = 1.15, DESKTOP_MIN_FIT = 0.6;
  function stickyTop() {
    var h = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') h += el.getBoundingClientRect().height;
    });
    return h;
  }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var scripts = {};
  function loadScript(src) {
    if (!scripts[src]) {
      scripts[src] = new Promise(function (res, rej) {
        var s = document.createElement('script');
        s.src = src; s.async = true; s.onload = res; s.onerror = rej;
        document.head.appendChild(s);
      });
    }
    return scripts[src];
  }
  function hasWebGL() {
    try { var c = document.createElement('canvas'); return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); }
    catch (e) { return false; }
  }
  function smooth(a, b, x) { var k = Math.min(1, Math.max(0, (x - a) / (b - a))); return k * k * (3 - 2 * k); }

  /* ---------- hero ---------- */
  function Hero(root) {
    this.root = root;
    this.el = root.querySelector('[data-fhs-hero]');
    if (!this.el) return;
    this.stage = this.el.querySelector('[data-fhs-stage]');
    this.gl = this.el.querySelector('[data-fhs-gl]');
    this.lblA = this.el.querySelector('[data-fhs-lbl="a"]');
    this.lblB = this.el.querySelector('[data-fhs-lbl="b"]');
    this.replayBtn = this.el.querySelector('[data-fhs-replay]');
    this.mode = null; this.engine = null; this.loading = false; this.dead = false;
    var self = this;
    this.onResize = function () { self.layout(); };
    window.addEventListener('resize', this.onResize, { passive: true });
    this.layout();
    if (this.replayBtn) this.replayBtn.addEventListener('click', function () { if (self.engine) self.engine.replay(); });
    if (!hasWebGL()) { this.fallback(); return; }
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { self.io.disconnect(); self.load(); } });
      }, { rootMargin: '600px 0px' });
      this.io.observe(this.el);
    } else { this.load(); }
  }
  Hero.prototype.currentMode = function () { return window.innerWidth <= MOBILE_MAX ? 'mobile' : 'desktop'; };
  Hero.prototype.layout = function () {
    var mode = this.currentMode(), cfg = HERO[mode], w = this.el.clientWidth;
    var scale = w / cfg.width;
    if (mode === 'desktop') {
      // fit the whole stage in the screen below the sticky header, so short/wide laptop screens see the full composition
      var avail = window.innerHeight - stickyTop();
      scale = Math.min(1, scale, Math.max(DESKTOP_MIN_FIT, avail / cfg.height));
    } else scale = Math.min(MOBILE_SCALE_CAP, scale);
    this.el.style.height = Math.round(cfg.height * scale) + 'px';
    this.el.style.setProperty('--fhs-s', scale.toFixed(4));
    this.el.style.aspectRatio = 'auto';
    this.stage.style.transform = 'translateX(-50%) scale(' + scale + ')';
    this.stage.style.left = '50%';
    this.stage.style.transformOrigin = '50% 0';
    this.stage.style.marginLeft = '0';
    if (this.mode && mode !== this.mode && this.engine) this.mount(); // breakpoint change: remount with the other config
    this.mode = this.mode || mode;
  };
  Hero.prototype.fallback = function () {
    this.el.classList.add('is-static');
    if (this.replayBtn) this.replayBtn.hidden = true;
  };
  Hero.prototype.load = function () {
    var self = this, d = this.root.dataset;
    if (this.loading) return; this.loading = true;
    loadScript(d.three).then(function () { return loadScript(d.engine); }).then(function () {
      if (self.dead) return;
      if (!window.THREE || !window.FHHero) throw new Error('hero scripts missing');
      var fam = '"Recoleta-Light"';
      var ready = (document.fonts && document.fonts.load) ? document.fonts.load(HERO.desktop.fontPx + 'px ' + fam).catch(function () {}) : Promise.resolve();
      return ready.then(function () { self.mount(); });
    }).catch(function () { self.fallback(); });
  };
  Hero.prototype.labelFrame = function (t) {
    var put = function (el, a) { if (!el) return; el.style.opacity = a.toFixed(3); el.style.transform = 'translateY(' + ((1 - a) * 12).toFixed(2) + 'px)'; };
    put(this.lblA, smooth(4.4, 7.8, t));
    put(this.lblB, smooth(4.9, 8.3, t));
  };
  Hero.prototype.mount = function () {
    var self = this, d = this.root.dataset, mode = this.currentMode(), cfg = HERO[mode];
    if (this.engine) { try { this.engine.destroy(); } catch (e) {} this.engine = null; }
    this.mode = mode;
    // fresh canvases every mount: a disposed WebGL context can't be reused
    this.gl.innerHTML = '';
    var cv = document.createElement('canvas'), ov = document.createElement('canvas');
    cv.setAttribute('aria-hidden', 'true'); ov.setAttribute('aria-hidden', 'true');
    this.gl.appendChild(cv); this.gl.appendChild(ov);
    var nums = [d.numA || '', d.numB || ''];
    try {
      this.engine = window.FHHero.mount(cv, ov, {
        speed: parseFloat(d.speed) || 1.7,
        width: cfg.width, height: cfg.height, bagCenterY: cfg.bagCenterY, bagHeight: cfg.bagHeight,
        aspect: cfg.aspect, depth: cfg.depth, particles: cfg.particles,
        front: d.front, back: d.back, gusset: d.gusset,
        font: cfg.fontPx + 'px "Recoleta-Light", Georgia, serif',
        numbers: cfg.numbers.map(function (n, i) { return { text: nums[i], x: n.x, y: n.y, w: n.w }; }).filter(function (n) { return n.text; }),
        onLabels: function () {},
        onFrame: function (t) { self.labelFrame(t); }
      });
      if (this.replayBtn) this.replayBtn.hidden = false;
    } catch (e) { this.fallback(); }
  };
  Hero.prototype.destroy = function () {
    this.dead = true;
    window.removeEventListener('resize', this.onResize);
    if (this.io) this.io.disconnect();
    if (this.engine) { try { this.engine.destroy(); } catch (e) {} }
  };

  /* ---------- tabs ---------- */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-fhs-tab]'));
    function pick(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab, panel = document.getElementById(t.getAttribute('aria-controls'));
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(t); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, j = -1;
        if (k === 'ArrowRight') j = (i + 1) % tabs.length; else if (k === 'ArrowLeft') j = (i - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') j = 0; else if (k === 'End') j = tabs.length - 1;
        if (j > -1) { e.preventDefault(); pick(tabs[j], true); }
      });
    });
  }

  /* ---------- pillars ---------- */
  function initPillars(root) {
    var ps = Array.prototype.slice.call(root.querySelectorAll('[data-fhs-pillar]'));
    var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 1100px)');
    function pick(p) {
      if (p.classList.contains('is-active')) return;
      ps.forEach(function (x) { var on = x === p; x.classList.toggle('is-active', on); x.setAttribute('aria-expanded', on ? 'true' : 'false'); });
    }
    ps.forEach(function (p) {
      p.addEventListener('click', function () { pick(p); });
      p.addEventListener('mouseenter', function () { if (hoverable && hoverable.matches) pick(p); });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    var qs = Array.prototype.slice.call(root.querySelectorAll('[data-fhs-faq]'));
    qs.forEach(function (q) {
      q.addEventListener('click', function () {
        var open = q.getAttribute('aria-expanded') === 'true';
        qs.forEach(function (o) {
          var on = o === q && !open, a = document.getElementById(o.getAttribute('aria-controls'));
          o.setAttribute('aria-expanded', on ? 'true' : 'false'); if (a) a.hidden = !on;
        });
      });
    });
  }

  /* ---------- supply picker + add to cart ---------- */
  function openCart() {
    try {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        var refresh = (window.Rebuy.Cart && window.Rebuy.Cart.fetchShopifyCart) ? window.Rebuy.Cart.fetchShopifyCart() : Promise.resolve();
        Promise.resolve(refresh).catch(function () {}).then(function () {
          try { window.Rebuy.SmartCart.show(); } catch (e) { window.location.href = '/cart'; }
        });
        return;
      }
    } catch (e) {}
    window.location.href = '/cart';
  }
  function initSS(root) {
    var box = root.querySelector('[data-fhs-ss]'); if (!box) return;
    var btn = box.querySelector('[data-fhs-atc]'), err = box.querySelector('[data-fhs-err]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var input = box.querySelector('.fhs-tier__input:checked');
      var lab = input ? input.closest('.fhs-tier') : box.querySelector('.fhs-tier');
      if (!lab) return;
      var item = { id: parseInt(lab.dataset.variant, 10), quantity: 1 };
      var plan = parseInt(lab.dataset.plan, 10); if (plan) item.selling_plan = plan;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding...'; if (err) err.hidden = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { btn.disabled = false; btn.textContent = label; openCart(); })
        .catch(function () { btn.disabled = false; btn.textContent = label; if (err) err.hidden = false; });
    });
  }

  /* ---------- stir video: plays while on screen ---------- */
  function initVideo(root) {
    var v = root.querySelector('[data-fhs-video]'); if (!v) return null;
    v.muted = true; v.defaultPlaybackRate = 1.3;
    if (reduceMotion) { v.removeAttribute('autoplay'); v.setAttribute('controls', ''); v.preload = 'metadata'; return null; }
    if (!('IntersectionObserver' in window)) { v.preload = 'auto'; v.play().catch(function () {}); return null; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (v.preload !== 'auto') v.preload = 'auto'; v.playbackRate = 1.3; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    io.observe(v);
    return io;
  }

  /* ---------- boot ---------- */
  var instances = new Map();
  function init(root) {
    if (!root || instances.has(root)) return;
    var inst = { hero: new Hero(root) };
    initTabs(root); initPillars(root); initFaq(root); initSS(root);
    inst.vio = initVideo(root);
    instances.set(root, inst);
  }
  function destroy(root) {
    var inst = instances.get(root); if (!inst) return;
    if (inst.hero && inst.hero.destroy) inst.hero.destroy();
    if (inst.vio) inst.vio.disconnect();
    instances.delete(root);
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-fhs]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-fhs]'); if (r) init(r); });
  document.addEventListener('shopify:section:unload', function (e) { var r = e.target.querySelector('[data-fhs]'); if (r) destroy(r); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b.matches && b.matches('[data-fhs-tab],[data-fhs-pillar]')) b.click();
    else if (b.querySelector) { var q = b.querySelector('[data-fhs-faq][aria-expanded="false"]'); if (q) q.click(); }
  });
})();
